"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/LedConfig.css");
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _styles = require("@mui/material/styles");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _react = require("react");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : LedConfig.js
* Description : Ce fichier contient la définition du composant LedConfig 
*               Ce composant affiche l'historique de la configuration des LEDs d'un Boxitunnel 
* Date de création : 13 mars 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ /* Hook */ /* Creation of the theme */
var CustomRadio = (0, _styles.styled)(_Radio["default"])({
  color: '#86C7A9',
  // Couleur lorsque décoché
  '&.Mui-checked': {
    color: '#86C7A9' // Couleur lorsque coché
  }
});
var CustomCheckbox = (0, _styles.styled)(_Checkbox["default"])({
  color: '#548235',
  // Couleur lorsque décoché
  '&.Mui-checked': {
    color: '#548235' // Couleur lorsque coché
  }
});

/**
* LedConfig : ce composant affiche l'historique de la configuration des LEDs d'un Boxitunnel 
*
* Type : composant 
*
* Parametres : 
*  - led_setting -- configuration des LEDs à afficher
*/
function LedConfig(_ref) {
  var equipment_id = _ref.equipment_id,
    date = _ref.date,
    ledSettingsProp = _ref.ledSettings;
  // Define useState hooks
  var _useState = (0, _react.useState)(ledSettingsProp || []),
    _useState2 = _slicedToArray(_useState, 2),
    ledSettings = _useState2[0],
    setLedSettings = _useState2[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  } // Define useEffect hooks
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, resLed, dataLed;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve ledSettings list
            _context.n = 1;
            return fetch(path + "/api/eq-lese/latest/?equipment_id=" + equipment_id + "&datetime=" + date, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resLed = _context.v;
            _context.n = 2;
            return resLed.json();
          case 2:
            dataLed = _context.v;
            setLedSettings(dataLed);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _retrieveData.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      retrieveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
      component: _Paper["default"],
      className: "margin-bottom margin-top table-border",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table["default"], {
        sx: {
          minWidth: 280
        },
        size: "small",
        "aria-label": "a dense table",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Date"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Type de param\xE8trage"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Horaires / Dur\xE9e"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                className: "table-label",
                children: "Jours / R\xE9p\xE9tition"
              })
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableBody["default"], {
          children: ledSettings && ledSettings.length !== 0 ? ledSettings.map(function (setting) {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
              sx: {
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                component: "th",
                scope: "row",
                children: setting['datetime']
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: setting['status'] === 'Slot' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  children: "P\xE9riode"
                }) : setting['status'] === 'Timer' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  children: "Minuteur"
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  children: "Continu"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: setting['status'] === 'Slot' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                    children: [setting['start_hour'], "h", setting['start_minute'], " - ", setting['stop_hour'], "h", setting['stop_minute']]
                  }), setting['period2_enable'] === 1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                    children: [setting['start_hour_period2'], "h", setting['start_minute_period2'], " - ", setting['stop_hour_period2'], "h", setting['stop_minute_period2']]
                  }) : null]
                }) : setting['status'] === 'Timer' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                  children: [setting['hour_timer'], "h ", setting['minute_timer'], "min ", setting['second_timer'], "s"]
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  children: "00h00 - 23h59"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                children: setting['status'] === 'Slot' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "led-config-days-grid led-config-days-letter",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "L"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "M"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "M"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "J"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "V"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "S"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "D"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "led-config-days-grid",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: Boolean(setting['day_1'])
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: Boolean(setting['day_2'])
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: Boolean(setting['day_3'])
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: Boolean(setting['day_4'])
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: Boolean(setting['day_5'])
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: Boolean(setting['day_6'])
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: Boolean(setting['day_7'])
                    })]
                  })]
                }) : setting['status'] === 'Timer' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "flex-row justify-start",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    children: "R\xE9p\xE9tition activ\xE9e : "
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    children: " Oui"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomCheckbox, {
                    checked: Boolean(setting['repeat_timer_enable'])
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    children: "Non"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomCheckbox, {
                    checked: !Boolean(setting['repeat_timer_enable'])
                  })]
                }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "led-config-days-grid led-config-days-letter",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "L"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "M"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "M"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "J"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "V"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "S"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                      children: "D"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "led-config-days-grid",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: 1
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: 1
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: 1
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: 1
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: 1
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: 1
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CustomRadio, {
                      checked: 1
                    })]
                  })]
                })
              })]
            }, setting.id);
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: "Aucun param\xE8trage ne correponds au filtrage s\xE9lectionn\xE9."
          })
        })]
      })
    })
  });
}
var _default = exports["default"] = LedConfig;